import { defineComponent } from 'vue';
import BaseSocials from '../../mixins/BaseSocial/BaseSocial.js';
import getSerialisedParams from '../../utils/getSerialisedParams.js';

/**
 * Hey!
 *
 * SWhatsApp component used for WhatsApp social network
 * @link https://whatsapp.com
 */
/**
 * Share parameters for link
 * @link https://faq.whatsapp.com/general/chats/how-to-use-click-to-chat
 */

var SWhatsApp = /* #__PURE__ */defineComponent({
  name: 'SWhatsApp',
  mixins: [BaseSocials('WhatsApp')],
  computed: {
    networkURL: function networkURL() {
      var BASE_URL = 'https://api.whatsapp.com/send';
      var shareOptions = this.shareOptions;
      var number = shareOptions.number,
          text = shareOptions.text;
      var serialisedParams = getSerialisedParams({
        phone: number,
        text: text
      });
      return "".concat(BASE_URL).concat(serialisedParams);
    }
  },
  render: function render() {
    return this.generateComponent(this.networkURL);
  }
});

export default SWhatsApp;
